export const TEXT_TYPES = {
  ITEM: 'ITEM',
  CHOICE: 'CHOICE',
  INTERACTION_BASE: 'INTERACTION_BASE',
  DASHBOARD: 'DASHBOARD',
  BQUI: 'BQUI',
  EMAIL: 'EMAIL',
  ERROR: 'ERROR',
  REPORT: 'REPORT',
  BI: 'BI',
};

// Default locale if BE is not working
export const DEFAULT_LOCALE_EN_US = {
  id: 'EN_US',
  tag: 'EN-us',
  language: 'EN',
  currency: '$',
  currencyFormatted(value) {
    return this.currency + value;
  },
  thousands: ',',
  dateFormat: 'MM/DD/YYYY',
  dateFormatLong: 'MMMM D, YYYY',
  d3DateFormatShort: '%b %d %Y',
  fileNameDateFormat: 'MM-DD-YYYY',
  text: 'English US',
};

// This is no longer the source of allowed locales (the BE is). Use this only as reference locales
export const LOCALES = {
  DE_DE: {
    id: 'DE_DE',
    language: 'DE',
  },
  EN_US: {
    id: 'EN_US',
    language: 'EN',
  },
};
